module.exports = __webpack_public_path__ + "img/1-light.12fd62bd.png";